import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { formatDateDDMMYYYY } from "../../../../helpers/functions/dateFormatter";

function splitLongWords(text, maxLength) {
  // Split text into words
  const textInString = text?.toString();
  const words = textInString?.split(" ");
  const newWords = words?.map((word) => {
    // If a word is longer than maxLength, split it
    if (word.length > maxLength) {
      let parts = [];
      for (let i = 0; i < word.length; i += maxLength) {
        parts.push(word.substring(i, i + maxLength));
      }
      return parts.join("\n"); // Join parts with a newline character
    }
    return word;
  });
  return newWords?.join(" ");
}

const TFUDCDocumentPDF = ({ formData }) => {
  const styles = StyleSheet.create({
    page: {
      flexDirection: "row",
      fontSize: 12,
      paddingVertical: 50,
      fontFamily: "Times-Roman",
      lineHeight: 1.5,
    },
    section: {
      flexGrow: 1,
      paddingHorizontal: 50,
    },
    heading: {
      color: "black",
      fontWeight: "bold",
      textDecoration: "underline",
      textAlign: "center",
      fontFamily: "Times-Roman",
    },
    table: {
      display: "table",
      width: "auto",
      borderStyle: "solid",
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
    },
    tableRow: {
      flexDirection: "row",
    },
    tableCol: {
      flex: 1, // Equal width columns
      borderStyle: "solid",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      padding: 4,
    },
    tableCell: {
      fontSize: 10,
    },
    bold: {
      fontWeight: "bold",
      fontSize: 10,
      fontFamily: "Times-Bold",
    },
  });


  function formatCurrencyText(input) {
    return input
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize each word
      .replace(/\bLakh\b/, "Lakhs"); // Optionally convert "Lakh" to "Lakhs"
  }

  const formattedValue = formatCurrencyText(formData?.amount_in_word);

  const formattedAmount = formData.creditLimit.toLocaleString("en-IN");

  const date = formData?.date || "";
  const currentDate = new Date();
  const formatedTodaysDate =
    date !== "" ? formatDateDDMMYYYY(date) : formatDateDDMMYYYY(currentDate);
  const personName = formData?.personName || "";
  const companyName = formData?.companyName || "";
  const dealerName = formData?.dealerName !== undefined && formData?.dealerName !== '' ? formData?.dealerName : (formData?.personName || "");
  const creditLimit = formattedAmount;
  const amountInWord = formattedValue;
  const PanNo = formData?.pan_no || "";
  const address = formData?.address || "";

  const cheque_number = formData?.tf_cheque_number
    ? formData?.tf_cheque_number
    : "";
  const cheque_number_2 = formData?.tf_cheque_number_2
    ? formData?.tf_cheque_number_2
    : "";
  const account_no = formData?.account_no ? formData?.account_no : "";
  const bank_name = formData?.bank_name ? formData?.bank_name : "";
  const branch = formData?.branch ? formData?.branch : "";
  const registrationNumber = formData?.registrationNumber
    ? formData?.registrationNumber
    : "300000";

  const vehicleData = {
    headers: [
      "Cheque No.",
      "Amount",
      "Date",
      "Account No.",
      "Bank Name & Branch Address",
    ],
    rows: [
      [cheque_number, " ", " ", account_no, `${bank_name},${branch}`],
      [
        cheque_number_2,
        " ",
        " ",
        account_no,
        `${bank_name},${branch}`,
      ],
    ],
  };

  const assuranceText = `We wish to confirm and acknowledge that to recover the payment extended under the Facility Agreement; you can encash the said Cheques, after filling up the date and amount, forthwith without further notice to us, without prejudice to your other rights available under the Finance Documents and under applicable law, equity or otherwise. 
We further represent and warrant that the said un-dated Cheque(s) shall be honoured upon presentation and we shall not raise any excuse or defense or claim on issue of our liability under the Finance Documents in any manner and undertake to reissue fresh Cheque(s) in the event any of the aforementioned Cheque(s) expire.`;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              textAlign: "right",
            }}
          >
            <Text>To,</Text>
            <View
              style={{
                flexDirection: "row",
              }}
            >
              <Text>Date: ______________________</Text>
              <Text
                style={{
                  fontWeight: "bold",
                  color: "rgb(103, 103, 103)",
                  fontSize: 10,
                  fontWeight: "900",
                  // marginBottom: -20,
                }}
              >
                Sign Here
              </Text>
            </View>
          </View>
          <Text style={styles?.bold}>
            {
              "\nTyger Capital Private Limited (Formerly Known as Adani Capital Private Limited)"
            }
          </Text>
          <Text>1004/5, Level 10,</Text>
          <Text>C Wing, One BKC,</Text>
          <Text>Bandra Kurla Complex, Bandra (East),</Text>
          <Text>Mumbai - 400051</Text>

          <Text style={[styles?.bold, { marginTop: 10 }]}>Kind Attention</Text>
          <View
            style={[
              styles?.bold,
              {
                display: "flex",
                flexDirection: "row",
                marginTop: 10,
              },
            ]}
          >
            <Text>Re: </Text>
            <Text>
              {/* <Text style={{ fontWeight: "bold", color: "black" }}> */}
              Submission of un-dated Cheques in connection with Inventory
              Finance Facility Agreement
            </Text>
          </View>
          <Text style={{ marginTop: 10 }}>Dear Sir,</Text>

          {/* <Text>{introductionText}</Text> */}
          {/* <Text style={{ marginTop: 10 }}>{content}</Text> */}

          <View style={{ flexDirection: "row", marginTop: 10 }}>
            {formData?.businessType === "individual" ? (
              <Text style={[styles.paragraph, { flex: 1 }]}>
                {`I `}
                <Text style={styles.bold}>{dealerName}</Text>
                {`, (the “Dealer” / “us” / “our” / “we”) refer to the revolving short term loan for an aggregate amount not exceeding Rs.`}
                <Text style={styles.bold}>{creditLimit}</Text>
                {`/-   (the “Inventory Finance Facility”) availed by us from the Company pursuant to the terms of the Facility Agreement and such other documents which have been / shall be executed between the Company and us (collectively, the “Finance Documents”), for supply / sale of certain products by the Anchor to us.
  All capitalized terms used in this letter and unless otherwise defined herein or unless the context otherwise requires, shall have the meaning ascribed to such terms in the Facility Agreement.
We are required to provide un-dated Cheque(s) for an aggregate amount of the Facility Limit to the Company. In furtherance of the same, we hereby enclose the below mentioned un-dated Cheque(s) in favour of the Company:`}
              </Text>
            ) : (
              <Text style={[styles.paragraph, { flex: 1 }]}>
                {`We M/S `}
                <Text style={styles.bold}>{companyName}</Text>
                {formData?.businessType !== "partnership" && (
                  <Text style={styles.bold}>{` (Prop: ${dealerName})`}</Text>
                )}
                {` (the “Dealer” / “us” / “our” / “we”) refer to the revolving short term loan for an aggregate amount not exceeding Rs.`}
                <Text style={styles.bold}>{creditLimit}</Text>
                {`/-   (the “Inventory Finance Facility”) availed by us from the Company pursuant to the terms of the Facility Agreement and such other documents which have been / shall be executed between the Company and us (collectively, the “Finance Documents”), for supply / sale of certain products by the Anchor to us.
  All capitalized terms used in this letter and unless otherwise defined herein or unless the context otherwise requires, shall have the meaning ascribed to such terms in the Facility Agreement.
We are required to provide un-dated Cheque(s) for an aggregate amount of the Facility Limit to the Company. In furtherance of the same, we hereby enclose the below mentioned un-dated Cheque(s) in favour of the Company:`}
              </Text>
            )}
          </View>

          {vehicleData?.rows?.length > 0 ? (
            <View style={styles.table}>
              {/* Table Header */}
              <View style={styles.tableRow}>
                {vehicleData.headers.map((header, i) => (
                  <View style={styles.tableCol} key={`header-${i}`}>
                    <Text style={[styles.tableCell, { fontWeight: "bold" }]}>
                      {header}
                    </Text>
                  </View>
                ))}
              </View>

              {/* Table Row */}
              {vehicleData.rows.map((row, rowIndex) => (
                <View style={styles.tableRow} key={`row-${rowIndex}`}>
                  {row.map((cell, cellIndex) => (
                    <View
                      style={styles.tableCol}
                      key={`cell-${rowIndex}-${cellIndex}`}
                    >
                      <Text style={styles.tableCell}>
                        {splitLongWords(cell, 20)}
                      </Text>
                    </View>
                  ))}
                </View>
              ))}
            </View>
          ) : (
            <View></View>
          )}

          <View
            style={{
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              height: 100,
              position: "relative",
              marginTop: -90,
            }}
          >
            <Text
              style={[
                {
                  transform: "rotate(270deg)",
                  transformOrigin: "top right",
                  position: "absolute",
                  right: -3,
                  bottom: 65,
                  fontWeight: "900",
                  color: "rgb(103, 103, 103)",
                  fontSize: 10,
                },
              ]}
            >
              Sign Here
            </Text>
          </View>

          <Text>{assuranceText}</Text>
          <View style={{ flexDirection: "row" }}>
            <Text style={{ fontWeight: "bold", color: "black" }}>
              Thanking you.{" "}
            </Text>
          </View>
          <View style={{ flexDirection: "row" }}>
            <Text
              style={{
                fontWeight: "bold",
                color: "rgb(103, 103, 103)",
                fontSize: 10,
                fontWeight: 900,
              }}
            >
              Sign Here
            </Text>
          </View>
          <View style={{ flexDirection: "row" }}>
            <Text style={{ fontWeight: "bold", color: "black" }}>
              Yours faithfully,
            </Text>
          </View>

          <View style={{ flexDirection: "row", marginTop: 10 }}>
            <Text style={{ fontWeight: "bold", color: "black" }}>
              For_______________________________________________________
            </Text>
          </View>
          <View style={{ flexDirection: "row", marginTop: 10 }}>
            <Text style={{ fontWeight: "bold", color: "black" }}>
              _______________________________________________________
            </Text>
          </View>
          <View style={{ flexDirection: "row" }}>
            <Text style={{ fontWeight: "bold", color: "black" }}>
              Authorized Signatory
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default TFUDCDocumentPDF;
